<script>
  import {CheckboxButton} from 'element-ui'
  export default {
    name:'ElCheckboxButton',
    extends:CheckboxButton
  }
</script>
